import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { assetStorageApi } from 'src/Services/API';
import { trackEvent } from 'src/Services/Matomo';

export const useMoveDocument = (
  options?: UseMutationOptions<void, unknown, { path: string; fileId: string }>
) => {
  const assetId = useCurrentAssetId();
  const queryClient = useQueryClient();

  return useMutation<void, unknown, { path: string; fileId: string }>(
    'move-document',
    async ({ fileId, path }) => {
      if (!assetId) {
        throw new Error('No asset selected');
      }
      const response = await assetStorageApi.assetStorageControllerMoveFile(assetId, fileId, {
        path,
      });
      return response.data;
    },
    {
      ...options,
      onSettled: (data, error, variables, context) => {
        options?.onSettled?.(data, error, variables, context);
        queryClient.invalidateQueries({ queryKey: ['fetch-documents', assetId] });
      },
      onSuccess: (data, variables, context) => {
        trackEvent('Document', 'move', 'file');
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
